import "./about.styles.scss";
import skills from "../../resources/skills";
import { useContext } from "react";
import { ScrollContext } from "../../context/scroll-to";
const About = () => {
  const SKILLS_DATA = skills;
  const { aboutSection } = useContext(ScrollContext);
  return (
    <section className="about- section" ref={aboutSection}>
      <div>
        <div>
          <h2 className="about-head">About</h2>
        </div>
        <div className="about-me">
          <article>
            Enthusiastic web-developer, learning frameworks, languages and
            developing applications and projects since <mark>2020</mark> .
            <br />
            <br />
            Looking to deliver excellent web development skills to help your
            business grow.
          </article>
        </div>

        <div className="skills section">
          <div>
            <h2 className="skills-head">Skills</h2>
          </div>
          <div className="skills-list">
            <ul>
              {SKILLS_DATA.map((skill) => (
                <li key={skill}>{skill}</li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
